/**
 * Business Product Card Component
 * 업체 상품/서비스 카드
 */

import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface Product {
  id: number;
  name: string;
  name_ko: string | null;
  description: string | null;
  description_ko: string | null;
  price_cents: number | null;
  currency: string;
  image_url: string | null;
  category: string | null;
  is_available: boolean;
  display_order: number;
}

interface BusinessProductCardProps {
  product: Product;
}

export function BusinessProductCard({ product }: BusinessProductCardProps) {
  const formatPrice = (cents: number | null, currency: string = "AUD") => {
    if (!cents) return "가격 문의";
    return `$${(cents / 100).toFixed(0)} ${currency}`;
  };

  return (
    <Card className="overflow-hidden hover:shadow-md transition-shadow">
      {product.image_url && (
        <div className="h-48 w-full overflow-hidden">
          <img
            src={product.image_url}
            alt={product.name}
            className="h-full w-full object-cover"
          />
        </div>
      )}
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="font-semibold text-lg">{product.name}</h3>
          {product.category && (
            <Badge variant="outline" className="text-xs">
              {product.category}
            </Badge>
          )}
        </div>
        {product.name_ko && (
          <p className="text-sm text-muted-foreground mb-2">{product.name_ko}</p>
        )}
        {product.description && (
          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
            {product.description}
          </p>
        )}
        <div className="flex items-center justify-between">
          <span className="font-bold text-lg">
            {formatPrice(product.price_cents, product.currency)}
          </span>
          {!product.is_available && (
            <Badge variant="secondary" className="text-xs">
              품절
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

